// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1C9Is","title":"Info_title__1l1CC","links":"Info_links__3gkGX","link":"Info_link__1SrOw","logo":"Info_logo__3bxko"};